<template>
	<div class="key-students">
		<div class="key-students-cont">
			<div class="keyStudents-title">
				<span>重点学生</span>
			</div>
			<div class="topTen-desc" v-if="haveData == 1">
				<span>本次考试排名前十的学生：</span>
			</div>
			<div class="topten-table" v-if="haveData == 1">
				<tables :tableOptions="examinationStudentsData"></tables>
			</div>
			<div class="topTen-desc">
				<span>本次考试本校排名前十的学生：</span>
			</div>
			<div class="topten-table">
				<tables :tableOptions="topTenGradeData"></tables>
			</div>
			<div style="height: 20px"></div>
			<div class="lastten-desc">
				<span>本次考试本校排名后十的学生：</span>
			</div>
			<div class="lastten-table">
				<tables :tableOptions="lastTenGradeData"></tables>
			</div>
			<div class="excellent-students">
				<div class="excestu-title">
					<div class="excestu-title-cont">
						<span>优秀学生人数班级分布：</span>
						<div class="Ranking-rate">
							<el-button type="" :class="RankFlag1 ? 'current' : ''" size="mini" @click="exceRankClick">名次</el-button>
							<el-button type="" :class="RankFlag2 ? 'current' : ''" size="mini" @click="exceRateClick">比例</el-button>
						</div>
						<div class="top-grade">
							<span>年级前</span>
							<el-input type="text" v-model="exceRanking" size="mini" @input="ExceRankingInpt"></el-input>
							<span>{{ exceDesc }}</span>
						</div>
					</div>
					<div>
						<el-button type="info" size="mini" :disabled="flag" @click="exceGradeStatistics">统计</el-button>
					</div>
				</div>
				<div class="excestu-table">
					<tables :tableOptions="goodStudentsData"></tables>
				</div>
			</div>
			<div class="improved-students">
				<div class="excestu-title">
					<div class="excestu-title-cont">
						<span>待提高学生人数班级分布：</span>
						<div class="Ranking-rate">
							<el-button type="" :class="improRankFlag ? 'current' : ''" size="mini" @click="ImproRankClick">名次</el-button>
							<el-button type="" :class="!improRankFlag ? 'current' : ''" size="mini" @click="ImproRateClick">比例</el-button>
						</div>
						<div class="top-grade">
							<span>年级后</span>
							<el-input v-model="improveRanking" size="mini" @input="improveRankingInpt"></el-input>
							<span>{{ improDesc }}</span>
						</div>
					</div>
					<div>
						<el-button type="info" size="mini" :disabled="newflag" @click="improveGradeStatistics">统计</el-button>
					</div>
				</div>
				<div class="excestu-table">
					<tables :tableOptions="improveStudentsData"></tables>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		tables: () => import('hm-table')
	},
	data() {
		return {
			tableOptions: [],
			improveStudentsData: [],
			examinationStudentsData: [],
			parType: '1',
			newParType: '1',
			exceRanking: '',
			improveRanking: '',
			exceDesc: '名',
			improDesc: '名',
			flag: false,
			newflag: false,
			RankFlag1: true,
			RankFlag2: false,
			improRankFlag: true,
			haveData: '',
			query: this.$route.query,
			topTenGradeData: [],
			lastTenGradeData: [],
			goodStudentsData: []
		}
	},
	mounted() {
		this.getTopRankingStudents() //排名前十的学生
		this.getLastRankingStudents() //排名后十的学生
		this.getExcellentStudents() //获取优秀学生
		this.getImproveStudents() //获取待提高学生
		this.getExaminationStudents() //获取联考学生成绩
	},
	methods: {
		getExaminationStudents() {
			const params = {
				examId: this.query.examId
			}
			this.$post('reportApi/selectImportantStudentFromAllStudent', params).then(res => {
				this.haveData = res.data.haveData
				this.examinationStudentsData = res.data.data
			})
		},
		getTopRankingStudents() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '1'
			}
			this.$post('reportApi/selectImportantStudent', params).then(res => {
				this.topTenGradeData = res.data.data
			})
		},
		getLastRankingStudents() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '2'
				// examSubjectId: ''
			}
			this.$post('reportApi/selectImportantStudent', params).then(res => {
				this.lastTenGradeData = res.data.data
			})
		},
		getExcellentStudents(parType = '1') {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '1',
				parType: parType,
				parameter: this.exceRanking
			}
			this.$post('reportApi/selectGoodOrBadStudent', params).then(res => {
				this.goodStudentsData = res.data.data
				this.exceRanking = res.data.parameter
			})
		},
		getImproveStudents(parType = '1') {
			// console.log(parType)
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '2',
				parType: parType,
				parameter: this.improveRanking
				// examSubjectId: ''
			}
			this.$post('reportApi/selectGoodOrBadStudent', params).then(res => {
				this.improveStudentsData = res.data.data
				this.improveRanking = res.data.parameter
			})
		},
		//输入优秀学生名次
		ExceRankingInpt(val) {
			var reg = /^[0-9]*[1-9][0-9]*$/
			if (this.parType == '1') {
				this.flag = false
				if (reg.test(val) || val == '') {
					if (val <= 50) {
						this.flag = false
					} else {
						this.$message('名次不能超过50')
						this.flag = true
					}
				} else {
					this.$message.error('请输入正整数')
					this.flag = true
				}
			} else if (this.parType == '2') {
				this.flag = false
				if (reg.test(val) || val == '') {
					if (val <= 30) {
						this.flag = false
					} else {
						this.$message.error('比例不能超过30%')
						this.flag = true
					}
				} else {
					this.$message.error('请输入正整数')
					this.flag = true
				}
			}
		},
		//输入待提高学生名次
		improveRankingInpt(val) {
			var reg = /^[0-9]*[1-9][0-9]*$/
			if (this.newParType == '1') {
				this.newflag = false
				if (reg.test(val) || val == '') {
					if (val <= 50) {
						this.newflag = false
					} else {
						this.$message('名次不能超过50')
						this.newflag = true
					}
				} else {
					this.$message('请输入正整数')
					this.newflag = true
				}
			} else if (this.newParType == '2') {
				this.newflag = false
				if (reg.test(val) || val == '') {
					if (val <= 30) {
						this.newflag = false
					} else {
						this.$message('比例不能超过30%')
						this.newflag = true
					}
				} else {
					this.$message('请输入正整数')
					this.newflag = true
				}
			}
		},
		exceGradeStatistics() {
			this.getExcellentStudents(this.parType)
		},
		improveGradeStatistics() {
			this.getImproveStudents(this.newParType)
		},
		//名次
		exceRankClick() {
			this.RankFlag1 = true
			this.RankFlag2 = false
			this.exceDesc = '名'
			this.parType = '1'
			if (this.exceRanking > 50) {
				this.flag = true
			} else {
				this.flag = false
			}
			this.getExcellentStudents(this.parType)
		},
		//比例
		exceRateClick() {
			this.RankFlag1 = false
			this.RankFlag2 = true
			this.exceDesc = '%'
			this.parType = '2'
			if (this.exceRanking > 30) {
				this.exceRanking = 30
			}
			if (this.exceRanking > 30) {
				this.flag = true
			} else {
				this.flag = false
			}
			this.getExcellentStudents(this.parType)
		},
		ImproRankClick() {
			this.improRankFlag = true
			this.improDesc = '名'
			this.newParType = '1'
			if (this.improveRanking > 50) {
				this.newflag = true
			} else {
				this.newflag = false
			}
			this.getImproveStudents(this.newParType)
		},
		ImproRateClick() {
			this.improRankFlag = false
			this.improDesc = '%'
			this.newParType = '2'
			if (this.improveRanking > 30) {
				this.improveRanking = 30
			}
			if (this.improveRanking > 30) {
				this.newflag = true
			} else {
				this.newflag = false
			}
			this.getImproveStudents(this.newParType)
		}
	}
}
</script>

<style lang="less" scoped>
.current {
	background-color: #009688;
	color: #fff;
	border: 1px solid #009688;
}
.key-students {
	height: auto;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	background-color: #fff;
	color: #303133;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	border-radius: 4px;
	overflow: hidden;
	.key-students-cont {
		height: auto;
		// background-color: wheat;
		.keyStudents-title {
			margin-bottom: 10px;
			> span {
				font-weight: bold;
				font-size: 18px;
				color: #333;
				margin-right: 20px;
			}
		}
		.topTen-desc,
		.lastten-desc {
			display: flex;
			height: 40px;
			margin-bottom: 5px;
			align-items: center;
			> span {
				font-size: 14px;
				flex-grow: 1;
			}
		}
		.topten-table,
		.lastten-table {
			height: auto;
			// background-color: skyblue;
			/deep/.cell {
				text-align: center;
			}
		}
		.excellent-students,
		.improved-students {
			height: auto;
			margin-top: 30px;
			// background-color: slateblue;
			.excestu-title {
				display: flex;
				height: 45px;
				align-items: center;
				margin-bottom: 5px;
				.excestu-title-cont {
					flex-grow: 1;
					display: flex;
					height: 45px;
					align-items: center;
					justify-content: space-between;
					margin-right: 30px;
					.Ranking-rate {
						width: 121px;
						height: 45px;
						// border: 1px solid skyblue;
						display: flex;
						align-items: center;
						justify-content: center;
						/deep/.el-button + .el-button {
							margin-left: 0px;
						}
						/deep/ .el-button:hover {
							color: #fff;
							background-color: #009688;
						}
					}
					.top-grade {
						width: 113px;
						height: 45px;
						// border: 1px solid tomato;
						display: flex;
						align-items: center;
						/deep/.el-input {
							width: 40%;
							margin: 0 3px;
						}
					}
				}
				> div:nth-child(2) {
					/deep/.el-button--info {
						background-color: #009688;
					}
				}
			}
			.excestu-table {
				height: auto;
				/deep/.cell {
					text-align: center;
				}
			}
		}
		.improved-students {
			margin-top: 30px;
		}
	}
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
}
</style>
